import FormFieldTimestamp from "components/FormFields/Timestamp";
import FormFieldViewText from "components/FormFields/ViewText";
import DescriptionDetails from "components/DescriptionDetails";
import Box from "ds/components/Box";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import FormField from "ds/components/Form/Field";
import Typography from "ds/components/Typography";
import { getProviderName } from "views/Account/Settings/Users/helpers";
import { useShowFullDescriptionWithBackArrow } from "ds/components/FullDescriptionDrawer/useShowFullDescriptionWithBackArrow";

import UserGroupStatusBadge from "../UserGroupStatusBadge";
import styles from "./styles.module.css";
import { IdpGroupView } from "../types";

type IdpGroupMappingDetailsDrawerContentProps = {
  group: IdpGroupView;
};

const IdpGroupMappingDetailsDrawerContent = ({
  group,
}: IdpGroupMappingDetailsDrawerContentProps) => {
  const onOpenFullDescription = useShowFullDescriptionWithBackArrow(group.description);
  const providerName = getProviderName(group.identityProvider);

  return (
    <>
      <DrawerHeader justify="between">
        <DrawerHeaderTitle title="Access details" />
        <DrawerCloseIcon />
      </DrawerHeader>
      <DrawerBody hasDivider={!!group.scimMetadata}>
        <FormFieldViewText label="IdP group ID" value={group.groupName} />
        <FormFieldViewText label="ID" value={group.id} withCopy />
        <DescriptionDetails
          description={group.description}
          onOpenFullDescription={onOpenFullDescription}
        />
        <FormFieldViewText label="Login method" value={providerName} noTextEllipsis />
        {group.lastLoginTime && (
          <FormFieldTimestamp timestamp={group.lastLoginTime} label="Last login" />
        )}

        <FormField label="Status" className={styles.status}>
          <UserGroupStatusBadge status={group.status} />
        </FormField>
      </DrawerBody>

      {group.scimMetadata && (
        <DrawerBody gap="x-large">
          <Box direction="column" gap="large" fullWidth>
            <Typography variant="p-t6" tag="h3">
              SCIM provisioning
            </Typography>
            <FormFieldViewText
              label="External ID"
              value={group.scimMetadata.externalId}
              noMargin
            />
          </Box>
        </DrawerBody>
      )}
    </>
  );
};

export default IdpGroupMappingDetailsDrawerContent;
